import type { SelectOption } from "@leabankab/component-library";

const canonical = (value: string) =>
	value.toLowerCase().replace(/[^\p{L}\p{N}]/gu, "");

export const matchOptionValue = (
	raw: string | undefined,
	options: SelectOption[]
): string => {
	const trimmed = raw?.trim();
	if (!trimmed) return "";

	const exact = options.find((option) => option.value === trimmed);
	if (exact) return exact.value;

	const needle = canonical(trimmed);
	if (!needle) return "";

	const loose = options.find(
		(option) =>
			canonical(option.value) === needle || canonical(option.label) === needle
	);

	return loose?.value ?? "";
};
